import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail } from 'lucide-react';
import './Footer.css';
import logo from '../../assets/vbc-logo.png'; // Updated to VBC logo

const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    setSubscribed(true);
    setTimeout(() => setSubscribed(false), 3000); // Reset after 3s
    setEmail('');
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <motion.div
          className="footer-content"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="footer-brand">
            <img alt="VBC Services LTD" className="footer-logo" src={logo} />
            <p className="footer-description">
              Your trusted Cash and Carry partner for bulk savings. VBC Services LTD, based in London, delivers premium wholesale goods at unbeatable prices across the UK.
            </p>
          </div>

          <div className="footer-contact">
            <motion.div className="contact-item" whileHover={{ scale: 1.05 }}>
              <div className="contact-detail">
                <Phone className="contact-icon" size={24} />
                <div>
                  <span className="contact-label">Phone</span>
                  <div className="contact-links">
                    <a href="tel:+447304244778">+44 7304 244778</a>
                  </div>
                </div>
              </div>
            </motion.div>
            <motion.div className="contact-item" whileHover={{ scale: 1.05 }}>
              <div className="contact-detail">
                <Mail className="contact-icon" size={24} />
                <div>
                  <span className="contact-label">Email</span>
                  <div className="contact-links">
                    <a href="mailto:vairagchaudhary98@gmail.com">vairagchaudhary98@gmail.com</a>
                  </div>
                </div>
              </div>
            </motion.div>
            <motion.div className="contact-item" whileHover={{ scale: 1.05 }}>
              <div className="contact-detail">
                <MapPin className="contact-icon" size={24} />
                <div>
                  <span className="contact-label">Warehouse</span>
                  <div className="contact-links">
                    12 Waghorn Road, London, E13 9JQ, UK
                  </div>
                </div>
              </div>
            </motion.div>
          </div>

          <div className="footer-links">
            <h4>Explore More</h4>
            <motion.a href="#products" whileHover={{ scale: 1.05 }}>Products</motion.a>
            <motion.a href="#about" whileHover={{ scale: 1.05 }}>About Us</motion.a>
            <motion.a href="#contact" whileHover={{ scale: 1.05 }}>Contact Us</motion.a>
          </div>

          <div className="footer-newsletter">
            <h4>Stay in the Loop</h4>
            <form className="newsletter-form" onSubmit={handleSubscribe}>
              <input
                type="email"
                className="newsletter-input"
                placeholder="Enter Your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <motion.button
                type="submit"
                className="newsletter-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Subscribe
              </motion.button>
            </form>
            {subscribed && (
              <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
                style={{ color: '#2e7d32', marginTop: '0.5rem' }}
              >
                Subscribed! Get ready for wholesale updates.
              </motion.p>
            )}
          </div>
        </motion.div>

        <div className="footer-bottom">
          <p className="footer-copyright">© 2025 VBC Services LTD. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;